$('.mobile-menu-icon .icon').on('click', function () {
    $(this).toggleClass('close')
    $('.mobile-menu').toggle()
    if (document.body.style.overflow === 'hidden') {
        document.body.style.overflow = 'auto'
    } else  {
        document.body.style.overflow = 'hidden'
    }
});

$('.mobile-menu .arrow').on('click', function (event) {
    if(event.target.nodeName === 'LI') {
        $(this).find('.submenu-list').toggle()
    }
});

// $(window).resize(function() {
//     if ($(window).width() >= '992'){
//         $('.head-menu').show()
//     } else {
//         $('.head-menu').hide()
//     }
// });
